import { ref } from "vue";

/**
 * 自動ログアウト処理中のグローバルローディング状態
 * autoLogout.js と AutoLogoutLoadingOverlay.vue で共有する
 */
export const isGlobalLoading = ref(false);
